import { EscoHrExpensesSection } from '../components/EscoHrExpensesSection';

/** People > Employees > Expenses: expense claims from escoHR, read-only. */
export function ExpensesPage() {
  return (
    <section className="card card--wide">
      <div className="section-header">
        <h2>Expenses</h2>
      </div>
      <EscoHrExpensesSection />
    </section>
  );
}
